import { render, staticRenderFns } from "./OrderExchangeShipped.vue?vue&type=template&id=665b0261&scoped=true"
import script from "./OrderExchangeShipped.vue?vue&type=script&lang=js"
export * from "./OrderExchangeShipped.vue?vue&type=script&lang=js"
import style0 from "./OrderExchangeShipped.vue?vue&type=style&index=0&id=665b0261&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665b0261",
  null
  
)

export default component.exports